
import { Box, Divider, FormControl, MenuItem, Typography } from "@mui/material"
import SelectField from "../../../components/styled/SelectField"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchLocations } from "../../../slices/common"
import Calendar from "../../../components/common/Calendar"
import { convertSlotsToEvents } from "../../../utils/generic/function"
import ApheresisUpdateForm from "./apheresisUpdateForm"
import { fetchSlotList, selectApheresEvents, selectApheresisLoading } from "../../../slices/apheresis"
import { AccessDenied } from "../../../../pages/access-denied/AccessDenied"
import { hasAuthority } from "../../../../utils/authorities"
import { SpinnerLoader } from "../../../../assets/loader/loader"
import ChatModule from "../../Chat"
import { addPatientList, addPhaseList } from "../../../slices/chat"

const BMRSlots = () => {
    const dispatch = useDispatch()
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || []
    const [allLocation, setAllLocation] = useState([])
    const allEvents = useSelector(selectApheresEvents)
    const [slotType, setSlotType] = useState("all")
    const [location, setLocation] = useState("")
    const [slotData, setSlotData] = useState(null)
    const [open, setOpen] = useState(false)
    const isLoading = useSelector(selectApheresisLoading)



    const fetchEvents = async () => {
        await dispatch(fetchSlotList({ location_id: location, slot_type: slotType }))
    }

    const getLocation = async () => {
        const res = await dispatch(fetchLocations())

        if (res?.payload?.status == 200) {
            setAllLocation(res?.payload?.data)
        }
    }

    useEffect(() => {
        if (allLocation.length != 0) {
            setLocation(allLocation?.items[0]?.id)
        }
    }, [allLocation])

    useEffect(() => {
        fetchEvents()
    }, [location, slotType])

    useEffect(() => {
        getLocation()
    }, [])

    const formOptions = [
        {
            type: 'select',
            name: 'location_id',
            placeholder: 'Select any location',
            options: allLocation?.items?.map(op => ({ value: op.id, label: op.name }))
        },
        {
            type: 'select',
            name: 'slot_type',
            placeholder: 'Select any type',
            options: [
                { value: "all", label: "All Slots" },
                { value: "available", label: "Available" },
                { value: "request", label: "Booked" },
                { value: "booked", label: "Confirmed" },
            ]
        },
    ]

    const handleCloseModal = () => {
        setOpen(false);
    };

    ////////// phase and pantient List for chat bot ///////////

    useEffect(() => {
            const phaseList = allEvents
                ?.filter(op => op?.status === 'Request' || op?.status === 'Booked')
                .map(op => ({
                    value: op?.phase_id,
                    label: `${op?.phase_name} (${op?.product_name})`,
                    patient_id: op?.subject_id
                }));

            const patientList = allEvents
                ?.filter(op => op?.status === 'Request' || op?.status === 'Booked')
                .map(op => ({
                    value: op?.subject_id,
                    label: `${op?.patient_name}`,
                    phase_id: op?.phase_id
                }));

            dispatch(addPatientList(patientList))
            dispatch(addPhaseList(phaseList))
    }, [allEvents])

    ////////////////////////////////////////////////////////////



    const handleSelectedSlot = (id, date, event) => {
        const extraProps = event?._def?.extendedProps

        if (extraProps?.type != "Available") {
            setSlotData({ id: id, date: date, ...extraProps, manufacturing_id: location, allLocation: allLocation })
            setOpen(true)
        }

    }
    return (<div className="mt-4 ml-0 rounded-lg p-4">
        {hasAuthority(["bmr-slots-view"], bmr_permissions) ? <div>
            <Box className="flex justify-content-between align-items-center p-3 relative bg-white">
                <div>
                    <Typography variant="h6">Select Slots</Typography>
                </div>
                <form className="flex  gap-2 align-items-center" >
                    <FormControl variant={"standard"}>
                        <div className="w-100 flex gap-2 align-items-center">
                            <SelectField
                                value={location}
                                onChange={(e) => {
                                    setLocation(e.target.value)
                                }}
                                sx={{
                                    '& .MuiSelect-select span::before': {
                                        color: '#808080',
                                        content: `"${formOptions[0].placeholder || '-- Select --'}"`,
                                    },
                                }}
                            >
                                <MenuItem value=""><em>{formOptions[0].placeholder || 'Select'}</em></MenuItem>
                                {formOptions[0]?.options?.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </SelectField>
                            <SelectField
                                value={slotType}
                                onChange={(e) => {
                                    setSlotType(e.target.value)
                                }}
                                sx={{
                                    '& .MuiSelect-select span::before': {
                                        color: '#808080',
                                        content: `"${formOptions[1].placeholder || '-- Select --'}"`,
                                    },
                                }}
                            >
                                <MenuItem value=""><em>{formOptions[1].placeholder || 'Select'}</em></MenuItem>
                                {formOptions[1].options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </SelectField>
                        </div>
                    </FormControl>
                </form>
            </Box>
            <div className="bg-white ">
                <Divider className="ml-2 mr-2" />
            </div>
            {isLoading ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="60vh" // or any suitable height
                >
                    <SpinnerLoader />
                </Box>) :

                <Calendar
                    handleSelectedSlot={handleSelectedSlot}
                    allEvents={location && convertSlotsToEvents(allEvents)}
                />}
            <ApheresisUpdateForm onClose={handleCloseModal} open={open} slotData={slotData ?? {}} handleCloseModal={handleCloseModal} fetchEvents={fetchEvents} />
            <ChatModule />
        </div>
            : <AccessDenied />}
    </div>)
}
export default BMRSlots